// The discrepancy list every domain returns; `id` is positional because the DTO carries none.
export const processDiscrepancyItems = (items) =>
  (items ?? []).map((item, index) => ({
    id: index,
    type: item.type,
    message: item.message,
  }));
